module.exports = __webpack_public_path__ + "img/ad_cn3.50243c79.png";